import React from "react";
import Package from "./Package";
import "./Packages.css";
import exterior from "./bucket.png";
import interior from "./chair.png";
import paint from "./paint.png";
function Packages() {
  const exteriorPackage = {
    name: "Exterior",
    image: exterior,
    cost: "$150",
  };
  const interiorPackage = {
    name: "Interior",
    image: interior,
    cost: "$150",
  };
  const paintPackage = {
    name: "Paint Correction",
    image: paint,
    cost: "$200",
  };
  return (
    <div className="packages">
      <Package packageType={exteriorPackage} />
      <Package packageType={interiorPackage} />
      <Package packageType={paintPackage} />
    </div>
  );
}

export default Packages;
